<template>
  <table class="table table-hover">
    <thead>
      <tr>
        <th
          v-for="(col, idx) in columns"
          v-bind:key="idx"
          v-on:mouseup="sortColumn(col.idx)"
          v-bind:class="{ 'text-center': col.center }"
          v-bind:aria-sort="ariaSort(col.idx)"
          class="c-hand"
        >
          {{ col.name }}<sub v-if="col.sub">{{ col.sub }}</sub>
          <span v-if="sortArrow(col.idx)">&nbsp;{{ sortArrow(col.idx) }}</span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(t, idx) in buses"
        v-bind:key="idx"
        v-on:mouseup="navigateToBus(t.idx)"
        class="c-hand"
      >
        <td>{{ t.bus[BUS_I] }}</td>
        <td>{{ busType(t.bus) }}</td>
        <td class="text-right">
          {{ t.bus[BASE_KV] }}<span class="hide-sm"> kV</span>
        </td>
        <td class="text-right">
          {{ t.bus[VM] }}<span class="hide-sm"> pu</span>
        </td>
        <td class="text-right">
          {{ t.bus[VA] }}<span class="hide-sm">&deg;</span>
        </td>
        <td class="text-right">
          <span v-if="t.bus[PD]">
            {{ t.bus[PD] }}<span class="hide-sm"> MW</span>
          </span>
        </td>
        <td class="text-right">
          <span v-if="t.bus[QD]">
            {{ t.bus[QD] }}<span class="hide-sm"> MVAr</span>
          </span>
        </td>
        <td class="text-right">
          <span v-if="t.bus[GS]">
            {{ t.bus[GS] }}<span class="hide-sm"> MW</span>
          </span>
        </td>
        <td class="text-right">
          <span v-if="t.bus[BS]">
            {{ t.bus[BS] }}<span class="hide-sm"> MVAr</span>
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import numeral from "numeral-es6";
import MPCStore from "../../stores/MPCStore";

import {
  BUS_I,
  BUS_TYPE,
  PD,
  QD,
  GS,
  BS,
  VM,
  VA,
  BASE_KV
} from "../../stores/idx";

export default {
  name: "BusTable",
  data() {
    return {
      columns: [
        { idx: BUS_I, name: "No." },
        { idx: BUS_TYPE, name: "Type" },
        { idx: BASE_KV, name: "V", sub: "b", center: true },
        { idx: VM, name: "V", sub: "m", center: true },
        { idx: VA, name: "V", sub: "a", center: true },
        { idx: PD, name: "P", sub: "d", center: true },
        { idx: QD, name: "Q", sub: "d", center: true },
        { idx: GS, name: "G", sub: "s", center: true },
        { idx: BS, name: "B", sub: "s", center: true }
      ],
      sorted: -1,
      ascending: false,
      BUS_I: BUS_I,
      BUS_TYPE: BUS_TYPE,
      PD: PD,
      QD: QD,
      GS: GS,
      BS: BS,
      VM: VM,
      VA: VA,
      BASE_KV: BASE_KV
    };
  },
  computed: {
    buses() {
      let idx = this.sorted;
      let up = this.ascending;
      return MPCStore.methods
        .getBuses()
        .map((bus, idx) => ({ bus, idx }))
        .sort(function(a, b) {
          if (idx >= 0) {
            return up ? b.bus[idx] - a.bus[idx] : a.bus[idx] - b.bus[idx];
          }
          return 0;
        });
    }
  },
  methods: {
    navigateToBus(idx) {
      this.$router.push({ name: "bus", params: { ord: idx + 1 } });
    },
    sortColumn(idx) {
      if (this.sorted === idx) {
        this.ascending = !this.ascending;
      } else {
        this.sorted = idx;
        this.ascending = false;
      }
    },
    ariaSort(idx) {
      if (this.sorted === idx) {
        return this.ascending ? "ascending" : "descending";
      }
      return "none";
    },
    sortArrow(idx) {
      if (this.sorted === idx) {
        return this.ascending ? "▴" : "▾";
      }
    },
    busType(bus) {
      switch (bus[BUS_TYPE]) {
        case 1:
          return "PQ";
        case 2:
          return "PV";
        case 3:
          return "Ref";
        case 4:
          return "Isolated";
      }
    },
    voltageMagnitude(bus) {
      return numeral(bus[VM]).format("0.[000]");
    },
    voltageAngle(bus) {
      return numeral(bus[VA]).format("0.[0]");
    }
  }
};
</script>
